import { useAxios } from 'hooks/useAxios';
import { AxiosErrorHandler } from 'shared/Helpers';
import { ExcelCreateRequest } from 'sb/models/ExcelJs';
import { BASE_URL_V2 } from 'shared/constants';

export const useExcelApi = () => {
  const { axios } = useAxios(BASE_URL_V2);

  /**
   * Create Excel file
   * @param formData
   */
  const createExcel = async (formData: ExcelCreateRequest) => {
    try {
      const res = await axios.post(`/excel/create`, formData, {
        responseType: 'blob'
      });
      return res.data;
    } catch (e) {
      AxiosErrorHandler(e);
    }
  };

  return {
    createExcel
  };
};
